import {FileInputValue} from './FileInputValue'

export class ImageInputValue extends FileInputValue {}
